 const aboutme =[
    {
        id:0,
        position:'SWE Intern',
        company:'INTUIT',
        time:'-(Feb, 2022 - Ongoing)',
        description:'Working in Customer Success under the Enterprise Data and Analytics team.'


    },
    {
        id:1,
        position:'Internship',
        company:'TEKIE',
        time:'-(May, 2021 - July, 2021)',
        description:'Tekie is an edu-tech company which teaches coding to 10+ years kids. Interned as a frontend engineer, I developed the client side of the web pages using ReactJS, Redux and implemented GraphQL queries to fetch data and display data in the corresponding components'


    },
    {
        id:2,
        position:'Moderator',
        company:'Developers Students Club, NIT Silchar',
        time:'-(August, 2020 - July,2021)',
        description:'DSC NIT Silchar is under Developer Students Club, which is a worldwide developers community initiated by Google. Headed the DSCCodeShare project under DSC, which is a web platform for efficient sharing of codes and an Android application, which was developed for efficient management of club activities of the college.'

    },
    {
        id:3,
        position:'Organiser',
        company:'SmartDroid 1.0, Spectrum 2020',
        time:'-(16,February, 2020 - 19,February, 2020)',
        description:'Organizer of SmartDroid,the first Android workshop cum Hackathon in technical week of Electronics and Communication Department, NIT Silchar.'

    }
];

export default aboutme